import {LeaveBlockComponent} from "./leave.block.component";
import {LeaveBlockGuard} from "./leave.block.guard";

export * from './leave.block.component';
export * from './leave.block.guard';
export * from './leave.blockable';

export const LEAVE_BLOCKABLE_COMPONENTS = [
    LeaveBlockComponent
];

export const LEAVE_BLOCKABLE_PROVIDERS = [
    LeaveBlockGuard
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/leave-block/index.ts